export default __webpack_public_path__ + "static/Lada Kalina-2be5e16db72f2ea3622c9b589f9038d6.jpg";